'use strict';

angular.module('amexReconciliationApp')
  .directive('withinUdfNumberRange',
  function withinUdfNumberRange(UserModel, CurrencyService) {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, elm, attrs, ngModel) {
        ngModel.$validators.withinUdfNumberRange = function (modelValue, viewValue) {
          if (UserModel.getCurrencyFormat() == 'COMMA') {
            viewValue = CurrencyService.switchCommasAndPeriods(viewValue);
          }

          var maxValue = 99999999999999.99;
          var minValue = -99999999999999.99;

          var value = parseFloat(String(viewValue).replace(/[,]/g, ''));

          return value <= maxValue && value >= minValue;
        };
      }
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/withinUDFNumberRange.js
// module id = 547
// module chunks = 0